module.exports = __webpack_public_path__ + "img/chenggong.c604be2f.png";